module.exports = __webpack_public_path__ + "static/media/landing_image.2b001119.png";